import { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './ConfirmDialog.scss';

const ConfirmDialog = ({ message, onConfirm, onCancel, isVisible }) => {
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="confirm-dialog-overlay" onClick={onCancel}>
            <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-dialog-header">
                    <div className="confirm-dialog-icon">
                        <AlertTriangle size={24} />
                    </div>
                    <h3>Confirm Action</h3>
                    <button className="confirm-dialog-close" onClick={onCancel} aria-label="Close">
                        <X size={20} />
                    </button>
                </div>
                <div className="confirm-dialog-body">
                    <p>{message}</p>
                </div>
                <div className="confirm-dialog-footer">
                    <button className="confirm-button cancel" onClick={onCancel}>
                        Cancel
                    </button>
                    <button className="confirm-button confirm" onClick={onConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
